import React from "react";

export interface LoginFormInitValues {
  username: string;
  password: string;
  name: string;
  email: string;
}

interface LoginFormInitProps {
  values: LoginFormInitValues;
  onChange: (field: keyof LoginFormInitValues, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  error: string;
}

const LoginFormInit: React.FC<LoginFormInitProps> = ({
  values,
  onChange,
  onSubmit,
  isLoading,
}) => {
  const { username, password, name, email } = values;
  const disabled =
    isLoading || !username.trim() || !password.trim() || !name.trim();

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label htmlFor="init-username" className="block text-sm font-medium text-gray-600 mb-1.5">
          System Owner Username
        </label>
        <input
          id="init-username"
          type="text"
          value={username}
          onChange={(e) => onChange("username", e.target.value)}
          placeholder="Choose a username"
          className="input-field"
          disabled={isLoading}
          autoComplete="username"
        />
      </div>
      <div>
        <label htmlFor="init-password" className="block text-sm font-medium text-gray-600 mb-1.5">
          Password
        </label>
        <input
          id="init-password"
          type="password"
          value={password}
          onChange={(e) => onChange("password", e.target.value)}
          placeholder="Choose a password"
          className="input-field"
          disabled={isLoading}
          autoComplete="new-password"
        />
      </div>
      <div>
        <label htmlFor="init-name" className="block text-sm font-medium text-gray-600 mb-1.5">
          Full Name
        </label>
        <input
          id="init-name"
          type="text"
          value={name}
          onChange={(e) => onChange("name", e.target.value)}
          placeholder="Enter your full name"
          className="input-field"
          disabled={isLoading}
        />
      </div>
      <div>
        <label htmlFor="init-email" className="block text-sm font-medium text-gray-600 mb-1.5">
          Email (Optional)
        </label>
        <input
          id="init-email"
          type="email"
          value={email}
          onChange={(e) => onChange("email", e.target.value)}
          placeholder="Enter your email"
          className="input-field"
          disabled={isLoading}
          autoComplete="email"
        />
      </div>
      <button
        type="submit"
        disabled={disabled}
        className="w-full btn-primary mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Initializing..." : "Initialize System"}
      </button>
    </form>
  );
};

export default LoginFormInit;
